// extracted by mini-css-extract-plugin
export var QuickGuideContainer = "style-module--QuickGuideContainer--fG87+";
export var QuickGuideSection = "style-module--QuickGuideSection--3mNj-";
export var QuickGuideText = "style-module--QuickGuideText--H7BUU";
export var QuickGuideVideo = "style-module--QuickGuideVideo--kIEXv";
export var QuickGuideVideoControls = "style-module--QuickGuideVideoControls--ulArI";